import { Stack } from "@fluentui/react"
import { Link, useLocation, useNavigate } from "react-router-dom"

import { L10n } from "@encoway/l10n"

import { TranslationConstants } from "../../constants/translationConstants"
import CsvExportButton from "../CsvExport/CsvExportButton"
import { DefaultPrimaryButton } from "../DefaultPrimaryButton/DefaultPrimaryButton"
import LoadConfigurationButton from "../LoadConfiguration/LoadConfigurationButton"
import SaveConfigurationButton from "../SaveConfigurationButton"
import SavedConfigurationCodeDisplay from "./SavedConfigurationCodeDisplay"

export default function ActionToolbar() {
    const navigate = useNavigate()
    const location = useLocation()

    function handleBack() {
        navigate("/")
    }

    return (
        <Stack
            horizontal
            horizontalAlign="space-between"
            style={{ padding: "1rem" }}
        >
            <DefaultPrimaryButton onClick={handleBack}>
                {L10n.format(
                    TranslationConstants.SalesContextSelector.BACK_BUTTON
                )}
            </DefaultPrimaryButton>

            <Stack horizontal style={{ gap: "1rem", justifyContent: "right" }}>
                <Link
                    to="/configuration/result/rooms"
                    state={{ backgroundLocation: location }}
                >
                    <DefaultPrimaryButton>
                        {L10n.format(
                            TranslationConstants.Toolbar.BUTTON_RESULT
                        )}
                    </DefaultPrimaryButton>
                </Link>
                <CsvExportButton />
                <SaveConfigurationButton />
                <LoadConfigurationButton />
                <SavedConfigurationCodeDisplay />
            </Stack>
        </Stack>
    )
}
